import { render, staticRenderFns } from "./InvalidForm.vue?vue&type=template&id=27b06317&"
import script from "./InvalidForm.vue?vue&type=script&lang=js&"
export * from "./InvalidForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports